import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[forScroll]', // Directive selector
})
export class ForScrollDirective {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
    this.applyStyles();
  }

  private applyStyles() {
    const element = this.el.nativeElement;
    this.renderer.setStyle(element, 'overflow', 'auto');
    this.renderer.setStyle(element, 'overflow-x', 'auto');
    this.renderer.setStyle(element, 'overflow-y', 'auto');
    this.renderer.setStyle(element, 'height', '100%');
    this.renderer.setStyle(element, 'padding-bottom', '10px');
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.renderer.setStyle(this.el.nativeElement, '--scrollbar-thumb-color', '#6e91d3');
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.renderer.setStyle(this.el.nativeElement, '--scrollbar-thumb-color', 'transparent');
  }
}
